<div class="dir-wrapper" [dir]="dir">
  <router-outlet></router-outlet>
  <div class="build-info" [hidden]="!buildInfoVisible">{{buildInfo}}</div>
  <div igxOverlayOutlet #overlay="overlay-outlet"></div>
</div>
